import { Router } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import React from 'react'
import { hydrate } from 'react-dom'
import { Provider } from 'react-redux'
import de from 'react-intl/locale-data/de'
import en from 'react-intl/locale-data/en'
import es from 'react-intl/locale-data/es'
import fr from 'react-intl/locale-data/fr'
import it from 'react-intl/locale-data/it'
import ja from 'react-intl/locale-data/ja'
import ko from 'react-intl/locale-data/ko'
import pl from 'react-intl/locale-data/pl'
import pt from 'react-intl/locale-data/pt'
import ro from 'react-intl/locale-data/ro'
import ru from 'react-intl/locale-data/ru'
import tr from 'react-intl/locale-data/tr'
import zh from 'react-intl/locale-data/zh'
import { HelmetProvider } from 'react-helmet-async'
import { addLocaleData, IntlProvider } from 'react-intl'
import App from './App'
import configureStore from './redux/store/configureStore'

// if (process.env.NODE_ENV === 'production') {
//   // A <script> tag is used instead of npm
//   /* eslint-disable no-undef */
//   const sentryDsn = process.env.RAZZLE_SENTRY_DSN
//   if (!sentryDsn) {
//     throw new Error('Could not find SENTRY_DSN in the environment variables for a production configuration')
//   }
//   Raven.config(sentryDsn).install()
// }

const store = configureStore(window.__PRELOADED_STATE__)

addLocaleData([
  ...de,
  ...en,
  ...es,
  ...fr,
  ...it,
  ...ja,
  ...ko,
  ...pl,
  ...pt,
  ...ro,
  ...ru,
  ...tr,
  ...zh,
])

const { locale, messages } = window.App

const history = window.__history__ || createBrowserHistory()
if (!window.__history__) {
  window.__history__ = history
}

const originalConsoleError = console.error
console.error = (...args) => {
  if (args[0] && typeof args[0] === 'string' && args[0].includes('[React Intl]')) {
    return
  }
  originalConsoleError.apply(console, args)
}

hydrate(
  <HelmetProvider>
    <IntlProvider locale={locale} messages={messages}>
      <Provider store={store}>
        <Router history={history}>
          <App />
        </Router>
      </Provider>
    </IntlProvider>
  </HelmetProvider>,

  document.getElementById('root')
)

if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default
    hydrate(
      <HelmetProvider>
        <IntlProvider locale={locale} messages={messages}>
          <Provider store={store}>
            <Router history={history}>
              <NextApp />
            </Router>
          </Provider>
        </IntlProvider>
      </HelmetProvider>,
      document.getElementById('root')
    )
  })
}
